/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_WorldwideInputs */



/**
* | output |
* | --- |
* | "Worldwide" |
*
* @param {League_WorldwideInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_worldwide = /** @type {((inputs?: League_WorldwideInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_WorldwideInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mondial")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mundial")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mundial")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mondiale")
	return /** @type {LocalizedString} */ ("Worldwide")
});